module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-home-layout.json
// module id = 169
// module chunks = 60335399758886 277288064929247